import { useEffect, useState } from "react";

export type ElementSize = { width: number; height: number };

/** Tracks an element's content box. Pass the element itself, not a ref, so it
 * re-measures when the node mounts late. */
export function useElementSize(element: Element | null): ElementSize {
  const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 });

  useEffect(() => {
    if (!element) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      if (entry) {
        setSize({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        });
      }
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [element]);

  return size;
}
